import { validators } from '../utils';
import { makeFormHook } from '../utils/factory';
import type { InferFormType } from '../utils/types';

export const giftTaskFormSchema = validators.object({
  recipientEmail: validators.email(),
  taskDescription: validators
    .requiredString('Task description')
    .max(500, 'Description must be 500 characters or fewer'),
});

export type GiftTaskFormSchema = InferFormType<typeof giftTaskFormSchema>;

export const giftTaskFormDefaultValues: GiftTaskFormSchema = {
  recipientEmail: '',
  taskDescription: '',
};

export const useGiftTaskForm = makeFormHook(giftTaskFormSchema, giftTaskFormDefaultValues);
